import {isEmpty} from 'lodash';
import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {api} from '../../api';
import {createQuery} from '../../lib';
import {createQuerySuspense} from '../../lib';

const {postCompaniesFindByIDs} = api.companies;

const postCompaniesFindByIdsRefresh = atom<number>({
  key: 'postCompaniesFindByIDsRefresh',
  default: 0,
});

const postCompaniesFindByIdsQuery = selectorFamily({
  key: 'postCompaniesFindByIDs',
  get(params: Parameters<typeof postCompaniesFindByIDs>[0]) {
    return async ({get}) => {
      if (isEmpty(params)) return;
      get(postCompaniesFindByIdsRefresh);
      try {
        const {data} = await postCompaniesFindByIDs(params);
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const usePostCompaniesFindByIdsQuerySuspense = createQuerySuspense(
  postCompaniesFindByIdsQuery,
  postCompaniesFindByIdsRefresh,
);

export const usePostCompaniesFindByIdsQuery = createQuery(postCompaniesFindByIdsQuery, postCompaniesFindByIdsRefresh);
